import { useStageState } from '../AppState.hooks';
import { RightSidebarContent } from './RightSidebarContent';
import React from 'react';

export const RightSidebar: React.VFC = () => {
    const { isReviewComplete } = useStageState();

    return isReviewComplete ? <RightSidebarContent /> : null;
};
